import React from 'react';
import functions from '../../../util/functions';
import { numberFormat } from '../../../util/araknerdlib';

const WalletStatement = ({statement, student, customRef}) => {
    return (
        <div ref={customRef}>
        <div className="content-wrapper d-flex">
            {/* Statement Header */}
            <div className="header-section" style={{ flex: 3 }}>
                <h4>Student Wallet Statement</h4>
                <p>
                    <strong>Student Name:</strong> {student?.full_name || 'N/A'} <br />
                    <strong>Class.:</strong> {student?.class?.class_name || 'N/A'} <br />
                    <strong>Reg No.:</strong> {student?.reg_no || 'N/A'} <br />
                    <strong>Payment Code</strong> {student?.payment_code || 'N/A'}

                </p>
                {functions.isObject(statement) && statement.summary && ( <p>
                    <strong>Statement Period:</strong>{' '}
                    {statement.summary.opening_date && <>{functions.formatDate(statement.summary.opening_date)} - {functions.formatDate(statement.summary.closing_date)}</>}
                </p>)}
            </div>

            {/* Statement Summary */}
            {functions.isObject(statement) && statement.summary && (
                <div className="summary-table" >
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th>Opening Balance</th>
                                <td>{numberFormat(statement.summary?.opening_balance || 0)}</td>
                            </tr>
                            <tr>
                                <th>Total Deposits</th>
                                <td>{numberFormat(statement.summary?.total_deposited || 0)}</td>
                            </tr>
                            <tr>
                                <th>Total Withdrawals</th>
                                <td>{numberFormat(statement.summary?.total_withdrawn || 0)}</td>
                            </tr>
                          
                            <tr>
                                <th>Closing Balance</th>
                                <td>{numberFormat(statement.summary?.closing_balance || 0)}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>

        {/* Transactions Table */}
        <div className="card mb-4">
            <div className="card-body">
                {functions.isObject(statement) && (
                    <table className="table table-striped table-bordered">
                        <thead className="thead-light">
                            <tr>
                                <th style={{textWrap: 'nowrap'}}>Trans. Date</th>
                                <th>Description</th>
                                <th>Deposit</th>
                                <th>Withdraw</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(statement.transactions) ? (
                                statement.transactions.map((transaction, index) => (
                                    <tr key={index}>
                                        <td style={{textWrap: 'nowrap'}}>{functions.formatDate(transaction.transaction_date)}</td>
                                        <td>{transaction.description || '-'}</td>
                                        <td>{transaction.deposit > 0 ? numberFormat(transaction.deposit) : ''}</td>
                                        <td>{transaction.withdrawal > 0 ? numberFormat(transaction.withdrawal) : ''}</td>
                                        <td>{numberFormat(transaction.running_balance)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        No transactions available for this period.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}

            </div>
        </div>
    </div>
    );
};

export default WalletStatement;